import React from 'react'
import { ReactComponent as Logo } from '../../assets/bgLogo.svg'
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index'
import './footer.css'

const Footer = ({ footerData, mobile }) => {
  let renderLink = (link) => {
    if (link.external) {
      return <a key={link.text} className={"footer-link white-text"} href={link.url} target={"_blank"} rel="noopener noreferrer" >{link.text}</a>
    } else {
      return <Link key={link.text} className={"footer-link white-text"} to={link.url}>{link.text}</Link>
    }
  }
  return (
    <div className={"app-footer " + (mobile ? "mobile" : "")}>
      <div className={"footer-side"}>
        <div className={"footer-copyright"}>
          <div className={"footer-logo"}>
            <Link to="/">
              <Logo fill={"#dfdfff"} alt={"Dark Logo"}/>
            </Link>
          </div>
          <p className={"footer-copytext"}>{footerData.copyright}</p>
        </div>
        <SocialLink socialLinks={footerData.socialLinks} />
      </div>
      <div className="footer-side links">
        {footerData.linkCols.map((item) => {
          return <div key={item.title} className={"footer-links"}>
            <h1 className={"footer-link title"}>{item.title}</h1>
            {item.links.map((link) => {
              return renderLink(link)
            })}
          </div>
        })
        }
      </div>
    </div>
  )
}

const SocialLink = ({ socialLinks }) => {
  return (
    <div className={"footer-social-icons"}>
      {socialLinks.map((link) =>
        // Don't open external links in new tab
        <a className={"footer-social-icon"} key={link.icon} href={link.link}>
          <FontAwesomeIcon icon={['fab', link.icon]} />
        </a>
      )}
    </div>
  )
}

export default Footer
